'use client';

import { KeyTextField } from '@prismicio/client';
import { Dispatch, SetStateAction, useState } from 'react';
import staticStyles from './tabs.module.scss';
import { useMounted, useOutsideClick, useScreenSize } from '@/hooks';
import { screenSizes } from '@/constants';
import { ArrowDown } from '@/assets';
import { CheckIcon } from '../Sort/assets/CheckIcon';

interface TabsProps {
  tabs: KeyTextField[];
  onClick: Dispatch<SetStateAction<number>>;
  styles?: string;
  activeItem: number;
  isVisible?: boolean;
  theme?: 'dark' | 'light';
  scrollDirection: 'bottom' | 'right';
}

export const Tabs = ({
  tabs,
  onClick,
  styles,
  activeItem,
  isVisible,
  theme = 'light',
  scrollDirection = 'right',
}: TabsProps) => {
  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false);

  const { width } = useScreenSize();
  const mounted = useMounted();

  const closeMenu = () => {
    if (width < screenSizes.tablet) {
      setIsOpenMenu(false);
    }
  };
  const ref = useOutsideClick<HTMLDivElement>(closeMenu);
  return (
    <div
      className={`${styles ?? ''} ${staticStyles.wrapper} ${staticStyles[scrollDirection]} ${isOpenMenu ? staticStyles.isOpen : ''} ${isVisible ? staticStyles.isVisible : ''} ${staticStyles[theme]}`}
      ref={ref}
    >
      {width < screenSizes.tablet && mounted && (
        <button
          type="button"
          className={`${staticStyles.current_item} ${isOpenMenu ? staticStyles.isOpen : ''} ${staticStyles[theme]}`}
          onClick={() => setIsOpenMenu((prev) => !prev)}
        >
          {tabs[activeItem]} <ArrowDown />
        </button>
      )}
      <ul
        className={`${staticStyles.tabs} ${isOpenMenu ? staticStyles.isOpen : ''} ${staticStyles[theme]}`}
      >
        {tabs.map((tab, index) => (
          <li
            key={tab}
            className={`${staticStyles.tab} ${staticStyles[theme]}`}
          >
            <button
              className={`${staticStyles.button} ${activeItem === index ? staticStyles.isActive : ''} ${staticStyles[theme]}`}
              type="button"
              onClick={() => {
                onClick(index);
                closeMenu();
              }}
            >
              <span>{tab}</span>
              <CheckIcon />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
